function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:4px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Asset 1");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "_",
  "data-name": "<"
}, React.createElement("polyline", {
  className: "cls-1",
  points: "25.6 46.96 2.83 24.19 25.6 1.41"
})));

var SvgLeftArrow = function SvgLeftArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 27.01 48.37",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLeftArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/left-arrow.45af70c3.svg";
export { ForwardRef as ReactComponent };